import React, { useEffect, useState } from "react";
import Dialog from "../../../../common/element/Dialog";
import { useDispatch } from "react-redux";
import { getCompanyProspectGeneratedUrl } from "../../../../redux/ProspectCompany/companyProspectSlice";

const CopyLinkURLModal = ({ dialogOpen, onDialogClose, onSubmit, companyData }) => {
    const [formData, setFormData] = useState({ interviewURL: "" });
    const [copied, setCopied] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (dialogOpen) {
            setCopied(false);
            if (companyData?.generateUrl) {
                setFormData({ interviewURL: companyData.generateUrl });
            }
        }
    }, [dialogOpen, companyData, dispatch]);

    const handleCopy = () => {
        if (formData.interviewURL) {
            navigator.clipboard.writeText(formData.interviewURL);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        }
    };

    const handleRefresh = () => {
        if (companyData?.company_id) {
            dispatch(getCompanyProspectGeneratedUrl(companyData.company_id)).then(action => {
                if (action.meta.requestStatus === "fulfilled") {
                    const data = action.payload?.data || action.payload;
                    setFormData({ interviewURL: data.generatedUrl || data.url || (typeof data === 'string' ? data : "") });
                }
            });
        }
    };

    return (
        <Dialog
            isOpen={dialogOpen}
            onClose={onDialogClose}
            width={800}
            bodyOpenClassName="overflow-hidden"
        >
            {/* Header */}
            <div className="flex items-center gap-3 px-6 pt-5 pb-5">
                <span className="h-9 w-9 flex items-center justify-center rounded-lg bg-gray-50 border border-gray-200">
                    {/* Link / chain icon */}
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.5572 2.08467C12.8959 0.740841 14.9577 0.631897 16.1625 1.84135C17.3673 3.0508 17.2588 5.12063 15.9201 6.46446L13.9811 8.41107M7.43673 10.601C6.23196 9.39155 6.34048 7.32168 7.67913 5.97785L9.39962 4.25068" stroke="#475467" strokeWidth="2" strokeLinecap="round" />
                        <path d="M10.5629 7.40088C11.7677 8.61032 11.6592 10.6802 10.3205 12.024L8.38147 13.9706L6.44241 15.9172C5.10377 17.261 3.0419 17.3699 1.83712 16.1605C0.632343 14.951 0.740872 12.8812 2.07952 11.5374L4.0186 9.59072" stroke="#475467" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </span>
                <h5 className="text-gray-900 text-base font-semibold mb-0">Interview URL</h5>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-200 mx-0" />

            {/* Body */}
            <div className="px-6 py-6">
                <div className="flex items-center gap-3">
                    <label className="text-sm font-medium text-gray-700 whitespace-nowrap w-[100px]">
                        Interview URL
                    </label>
                    <div className="flex flex-1 items-center gap-2">
                        <input
                            type="text"
                            value={formData.interviewURL}
                            readOnly
                            placeholder="Generate URL"
                            className="h-10 pl-3 flex-1 input input-shadow text-sm border border-gray-300 rounded-lg appearance-none text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white placeholder-gray-400"
                        />
                        <button
                            onClick={handleCopy}
                            title="Copy URL"
                            className="h-10 w-10 flex-shrink-0 flex items-center justify-center bg-[#FF8E1C] hover:bg-[#e67d0e] rounded-lg transition-colors duration-150"
                        >
                            {/* Copy icon */}
                            <svg width="18" height="18" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="7" y="7" width="11" height="13" rx="2" stroke="white" strokeWidth="2" fill="none"/>
                                <path d="M4 15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </button>
                    </div>
                </div>

                {copied && (
                    <p className="text-xs text-green-600 mt-2 ml-[112px]">
                        Copied to clipboard!
                    </p>
                )}
            </div>

            {/* Footer */}
            <div className="px-6 pb-5">
                <button
                    onClick={onDialogClose}
                    className="w-full h-10 rounded-lg font-medium text-sm text-gray-700   bg-[#FFF4E5]  transition-colors duration-150"
                >
                    Cancel
                </button>
            </div>
        </Dialog>
    );
};

export default CopyLinkURLModal;